<template>
  <div class="print-grade-answer">
    <div class="card second-card">
      <div class="card-body">
        <div class="d-fex" v-if="!reportVisible">
          <div class="p-2">
            <h2>채점표</h2>
          </div>
        </div>
        <div class="d-flex blue-gray">
          <div class="p-2">
            <h1 v-if="reportVisible" class="title">{{examInfo.exam_title}}</h1>
            <span v-else class="exam-title">{{examInfo.exam_title}}</span>
            <p><span class="gray">시험일자</span> {{examInfo.open_dt}}</p>
          </div>
          <div class="p-2 ml-auto rank text-nowrap rank-text">
            <div>
              <span class="number"><strong>{{examInfo.exam_score}}</strong></span> / <span class="numbe1">{{examInfo.quiz_score}}</span>
              <p class="center">{{`(${examInfo.exam_score_100})`}}</p>
            </div>
          </div>
        </div>

        <fieldset>
          <div class="d-flex">
            <div class="p-2">
              <h2>채점 결과</h2>
            </div>
            <div class="p-2">
              <strong><span class="number mint"></span></strong>
            </div>
          </div>
          <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition">
            <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
              <colgroup>
                <col width="20%" />
                <col width="25%" />
                <col width="25%" />
                <col width="30%" />
              </colgroup>
              <thead class="has-gutter">
                <tr>
                  <th class="is-center stone-table-cell stone-table-label">번호</th>
                  <th class="is-center stone-table-cell stone-table-label">나의 답</th>
                  <th class="is-center stone-table-cell stone-table-label">정답</th>
                  <th class="is-center stone-table-cell stone-table-label">해설</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="quiz in quizData" :key="quiz.quiz_seq" :with="className = getQuizCellClass(quiz.solution_yn)">
                  <td class="is-center stone-table-cell"><div :class="className">{{quiz.display_no}}</div></td>
                  <td class="is-center stone-table-cell"><div :class="className">{{getQuizItemNo(quiz.exam_answer)}}</div></td>
                  <td class="is-center stone-table-cell"><div :class="className">{{getQuizItemNo(quiz.solution)}}</div></td>
                  <td class="is-center stone-table-cell"><div :class="className" @click="viewDescrption(quiz)">해설 보기</div></td>
                </tr>
              </tbody>
            </table>
          </div>
        </fieldset>
      </div>
      <div class="p-2"></div>
    </div>

    <el-dialog :title="`${title}번 문제 정답 해설 (${point}점)`" class="item" width="80%" center :visible.sync="dialogVisible" append-to-body>
      <div v-html="description"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">닫기</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import common from '@/modules/common'
export default {
  name: 'R010101',
  mixins: [common.mixins],
  props: {
    isReport: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      quizData: [],
      examInfo: {
        exam_title: '',
        cate_path: '',
        class_name: '',
        user_name: '',
        picture_path: '',
        curriculum_yn: '',
        open_dt: '',
        correct_cnt: 0,
        wrong_cnt: 0,
        exam_score: 0,
        exam_score_100: 0,
        quiz_score: 0
      },
      itemNo: ['', '①', '②', '③', '④', '⑤'],
      userInfo: {
        download_url: '',
        name: '',
        id: '',
        school_name: ''
      },
      dialogVisible: false,
      description: '',
      title: '',
      point: 0,
      reportVisible: this.isReport
    }
  },
  created () {
    const params = this.$route.params
    if (params.exam_seq && params.class_seq && params.class_user_seq) {
      this.retrieve()
    } else {
      this.$router.push({name: 'LOGIN_S'})
    }
  },
  methods: {
    retrieve () {
      this.searchLoading = true
      common.axios.post('/report/exam/answer', this.$route.params)
        .then(response => {
          const result = response.data
          // console.log('result : ', result)
          Object.keys(this.examInfo).forEach(key => {
            this.examInfo[key] = result.exam[key]
          })
          this.quizData = result.exam_quiz
          this.searchLoading = false
          this.loadSuccess()
        })
        .catch(() => {
          this.searchLoading = false
        })
    },
    getQuizCellClass (solution) {
      return 'cell' + (solution === 'N' ? ' font-bold font-red' : '')
    },
    getQuizItemNo (value) {
      const no = value ? parseInt(value, 10) : 0
      return this.itemNo[no]
    },
    viewDescrption (quiz) {
      this.title = quiz.display_no
      this.point = quiz.point
      this.description = this.replaceCarriageReturnToBr(quiz.description)
      this.dialogVisible = true
    },
    loadSuccess () {
      this.$emit('load-success', this.examInfo)
    }
  }
}
</script>

<style scoped>
  .print-grade-answer {
    padding: 0;
  }
  .print-grade-answer .second-card .card-body {
    padding: 0 16px;
  }
  .exam-title {
    line-height: 36px;
    margin: 0;
    font-weight: 500;
    font-size: 18px
  }
</style>



// WEBPACK FOOTER //
// src/pages/R010100.vue